import { GrowthRateBasisType } from '@xplan-pension-switching/common';

export const getSuffixFromGrowthRateBasisType = (growthRate: GrowthRateBasisType): string => {
    if (growthRate === GrowthRateBasisType.IndustryStandard) {
        return `Standard`;
    }
    if (growthRate === GrowthRateBasisType.FundSpecificNominal) {
        return `Nominal`;
    }
    if (growthRate === GrowthRateBasisType.FundSpecificInflation) {
        return `Inflation`;
    }
    return '';
};
